export const MODULE_PAYMENT = 'payment'
export const SET_NEED_UPGRADE_SUBSCRIPTION_PLAN = 'SET_NEED_UPGRADE_SUBSCRIPTION_PLAN'
export const SET_UPGRADE_SUBSCRIPTION_PLAN_POPUP_TITLE = 'SET_UPGRADE_SUBSCRIPTION_PLAN_POPUP_TITLE'

export const MODULE_POPUP = 'popup'
export const SET_ARCHIVE_ALERT_POPUP_SHOW = 'SET_ARCHIVE_ALERT_POPUP_SHOW'
export const SET_PENDING_ALERT_TO_SAVE = 'SET_PENDING_ALERT_TO_SAVE'
export const SET_ADD_EDIT_ALERT_POPUP_SHOW = 'SET_ADD_EDIT_ALERT_POPUP_SHOW'
export const SET_ADD_NEW_ALERT_POPUP_SHOW = 'SET_ADD_NEW_ALERT_POPUP_SHOW'
export const SET_UPGRADE_SUBSCRIPTION_PLAN_POPUP_SHOW = 'SET_UPGRADE_SUBSCRIPTION_PLAN_POPUP_SHOW'
export const SET_UPGRADE_SUBSCRIPTION_PLAN_SUCCESS_POPUP_SHOW = 'SET_UPGRADE_SUBSCRIPTION_PLAN_SUCCESS_POPUP_SHOW'
export const SET_UPGRADE_SUBSCRIPTION_PLAN_FAILED_POPUP_SHOW = 'SET_UPGRADE_SUBSCRIPTION_PLAN_FAILED_POPUP_SHOW'

export const SET_WAREHOUSE_RACK_ADD_EDIT_POPUP_SHOW = 'SET_WAREHOUSE_RACK_ADD_EDIT_POPUP_SHOW'
export const SET_WAREHOUSE_SHELF_ADD_EDIT_POPUP_SHOW = 'SET_WAREHOUSE_SHELF_ADD_EDIT_POPUP_SHOW'
export const SET_WAREHOUSE_BIN_ADD_EDIT_POPUP_SHOW = 'SET_WAREHOUSE_BIN_ADD_EDIT_POPUP_SHOW'

export const SET_UNSAVED_CHANGES_POPUP_SHOW = 'SET_UNSAVED_CHANGES_POPUP_SHOW'
export const SET_SUBMIT_FORM_ERROR_POPUP_SHOW = 'SET_SUBMIT_FORM_ERROR_POPUP_SHOW'
export const SET_SUBMIT_FORM_ERROR_POPUP_TITLE = 'SET_SUBMIT_FORM_ERROR_POPUP_TITLE'
export const SET_SUBMIT_FORM_ERROR_POPUP_MESSAGE = 'SET_SUBMIT_FORM_ERROR_POPUP_MESSAGE'

export const SET_CONFIRM_POPUP_SHOW = 'SET_CONFIRM_POPUP_SHOW'
export const SET_CONFIRM_POPUP_TITLE = 'SET_CONFIRM_POPUP_TITLE'
export const SET_CONFIRM_POPUP_MESSAGE = 'SET_CONFIRM_POPUP_MESSAGE'

export const SET_CUSTOM_FIELD_POPUP_SHOW = 'SET_CUSTOM_FIELD_POPUP_SHOW'

export const SET_DELETE_ALERT_POPUP_SHOW = 'SET_CONFIRM_POPUP_SHOW'
export const SET_DELETE_ALERT_POPUP_DATA = 'SET_CONFIRM_POPUP_DATA'

export const SET_EXPORT_CONFIRM_POPUP_SHOW = 'SET_EXPORT_CONFIRM_POPUP_SHOW'
export const SET_EXPORT_CONFIRM_POPUP_TITLE = 'SET_EXPORT_CONFIRM_POPUP_TITLE'
export const SET_EXPORT_CONFIRM_POPUP_MESSAGE = 'SET_EXPORT_CONFIRM_POPUP_MESSAGE'
export const SET_EXPORT_CONFIRM = 'SET_EXPORT_CONFIRM'

export const SET_IMPORT_CONFIRM_POPUP_SHOW = 'SET_IMPORT_CONFIRM_POPUP_SHOW'
export const SET_IMPORT_CONFIRM_POPUP_TITLE = 'SET_IMPORT_CONFIRM_POPUP_TITLE'
export const SET_IMPORT_CONFIRM_POPUP_MESSAGE = 'SET_IMPORT_CONFIRM_POPUP_MESSAGE'
export const SET_IMPORT_CONFIRM = 'SET_IMPORT_CONFIRM'
export const SET_IMPORT_FILE = 'SET_IMPORT_FILE'

export const MODULE_FORM = 'form'
export const SET_FORM_DATA_ORIGIN = 'SET_FORM_DATA_ORIGIN'
export const SET_FORM_DATA_NEW = 'SET_FORM_DATA_NEW'
export const SET_NEED_CHECK_FORM_ON = 'SET_NEED_CHECK_FORM_ON'
export const SET_NEED_CHECK_FORM_OFF = 'SET_NEED_CHECK_FORM_OFF'
export const SET_SUBMIT_FORM_ERROR = 'SET_SUBMIT_FORM_ERROR'
export const SET_SUBMIT_FORM_ERROR_DATA = 'SET_SUBMIT_FORM_ERROR_DATA'

export const MODULE_SETTINGS = 'settings'
export const SET_SETTINGS_PAGE_SECTION = 'SET_SETTINGS_PAGE_SECTION'
export const SET_GENERAL_SETTINGS = 'SET_GENERAL_SETTINGS'

export const MODULE_USER = 'user'
export const MODULE_INVENTORY = 'inventory'
export const MODULE_CURRENCY = 'currency'
export const ROUTE_AFTER_LOGIN = 'ROUTE_AFTER_LOGIN'

export const SET_DATE_TIME_FORMAT = 'Set date time format'
export const SET_USER_RIGHTS = 'Set user rights'
export const SET_DATE_TIME_FORMATS = 'Set date time formats'
export const SET_DATE_TIME_FORMAT_ID = 'Set date time format ID'
export const SET_USER_PLAN = 'Set user plan'
export const SET_USED_WAREHOUSES = 'Set used warehouses'
export const SET_USED_ITEMS = 'Set used items'
export const SET_USED_CUSTOM_FIELDS = 'Set used custom fields'
export const SET_USED_USERS = 'Set used users'
